import { useState } from 'react';
import type { TVTeamFaceSlot } from './tv-team-faces';
import { TV_PALETTE } from './tv-mode.constants';

type Props = {
  slots: [TVTeamFaceSlot, TVTeamFaceSlot];
  size?: number;
  /** Equipo perdedor / menos énfasis */
  dimmed?: boolean;
};

function Face({
  slot,
  size,
  zIndex,
  marginLeft,
}: {
  slot: TVTeamFaceSlot;
  size: number;
  zIndex: number;
  marginLeft: number;
}) {
  const [imgOk, setImgOk] = useState(true);
  const showImg = slot.imageUrl && imgOk;
  const fontSize = Math.max(9, Math.round(size * 0.35));

  return (
    <div
      style={{
        width: size,
        height: size,
        marginLeft,
        borderRadius: '50%',
        flexShrink: 0,
        overflow: 'hidden',
        border: '2px solid #fff',
        boxSizing: 'border-box',
        zIndex,
        background: TV_PALETTE.card,
      }}
    >
      {showImg ? (
        <img
          src={slot.imageUrl!}
          alt=""
          width={size}
          height={size}
          onError={() => setImgOk(false)}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
          }}
        />
      ) : (
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#64748b',
            color: '#fff',
            fontSize,
            fontWeight: 700,
          }}
        >
          {slot.initials}
        </div>
      )}
    </div>
  );
}

export function TVTeamAvatarStack({
  slots,
  size = 26,
  dimmed = false,
}: Props) {
  const overlap = -Math.round(size * 0.28);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        opacity: dimmed ? 0.72 : 1,
      }}
    >
      <Face slot={slots[0]} size={size} zIndex={2} marginLeft={0} />
      <Face slot={slots[1]} size={size} zIndex={1} marginLeft={overlap} />
    </div>
  );
}
